import { render, staticRenderFns } from "./cerfityDraw.vue?vue&type=template&id=73961238"
import script from "./cerfityDraw.vue?vue&type=script&lang=js"
export * from "./cerfityDraw.vue?vue&type=script&lang=js"
import style0 from "./cerfityDraw.vue?vue&type=style&index=0&id=73961238&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports